import Controller from '@ember/controller';
import { service } from '@ember/service';
import type BetaToggleService from 'scaleflow/services/beta-toggle';

type Tab = {
  label: string;
  route: string;
  key: string;
};

export default class ScansScanProductController extends Controller {
  @service declare betaToggle: BetaToggleService;
  get tabs(): Tab[] {
    const tabs = [
      {
        label: 'Observations',
        route: 'scans.scan.product.observations',
        key: 'observations',
        hide: this.betaToggle.hideObservations,
      },
      // {
      //   label: 'Conversations',
      //   route: 'scans.scan.product.conversations',
      //   key: 'conversations',
      // },
      {
        label: 'Automated Reports',
        route: 'scans.scan.product.automated-reports',
        key: 'automated',
      },
      {
        label: 'Verified Reports',
        route: 'scans.scan.product.verified-reports',
        key: 'verified',
      },
    ];
    return tabs;
  }
}
